import React from "react";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { Box, Typography } from "@mui/material";
import Skeleton from "../Skeleton/Skeleton";

const Average = ({ label, average, isLoading }) => {
  return (
    <Box display="flex" alignItems="center" py={0.5}>
      <Typography variant="body2" sx={{ width: 88 }}>
        {label}
      </Typography>
      <Box flex={1}>
        <Skeleton
          height={16}
          loading={isLoading}
          width="100%"
          style={{ flex: 1 }}
        >
          <ProgressBar completedSteps={average} totalSteps={100} height={16} />
        </Skeleton>
      </Box>
      <Typography variant="subtitle2" sx={{ width: 54, textAlign: "end" }}>
        {average}%
      </Typography>
    </Box>
  );
};

export default Average;
